// Authentication hook - manages Appwrite auth state
import { useState, useEffect, useCallback } from "react";
import { account } from "../utils/appwrite";

export function useAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkSession = useCallback(async () => {
    try {
      const currentUser = await account.get();
      setUser(currentUser);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  const login = async (email, password) => {
    await account.createEmailPasswordSession(email, password);
    await checkSession();
  };

  const register = async (email, password, name) => {
    await account.create("unique()", email, password, name);
    await login(email, password);
  };

  const logout = async () => {
    await account.deleteSession("current");
    setUser(null);
  };

  return { user, loading, login, register, logout };
}
